import { Fetch } from '.';
import { Metadata } from '../types/Metadata';

const callContentMutation = async <T>(f: Fetch, body: string): Promise<T> => {
  const resp = await f.graphQLFetch(
    process.env.CPP_CONTENT_URI + '/document',
    body
  );
  return resp;
};

export const addProjectDerivativesRelationship =
  (f: Fetch) =>
  async (itemId: number[], parentItemId: number, isChildSelect: boolean) =>
    postProjectDerivativesRelationship(
      f,
      itemId,
      parentItemId,
      false,
      isChildSelect
    );

export const removeProjectDerivativesRelationship =
  (f: Fetch) =>
  async (itemId: number[], parentItemId: number, isChildSelect: boolean) =>
    postProjectDerivativesRelationship(
      f,
      itemId,
      parentItemId,
      true,
      isChildSelect
    );

const postProjectDerivativesRelationship = async (
  f: Fetch,
  itemId: number[],
  parentItemId: number,
  isRemove: boolean,
  isChildSelect: boolean
) => {
  if (!parentItemId) throw new Error('Missing parent item id.');
  if (itemId?.length == 0) throw new Error('Missing item id.');
  const relationshipArray = itemId?.map(
    i =>
      `{parentItemId: ${parentItemId}, itemId: ${
        isRemove ? 'null' : i
      }, relationshipTypeId: 700}`
  );
  const relationshipsString = relationshipArray.join(`,`);
  const resp = await callContentMutation<any>(
    f,
    `mutation { 
        upsertItemRelationship (
            relationships: [${relationshipsString}], itemId: ${
      isChildSelect ? parentItemId : itemId[0]
    }) { 
              success  errorMessage 
            }
      }`
  );
  if (resp.error || resp.errors || !resp?.upsertItemRelationship?.success) {
    let error = resp.error;
    if (resp.errors?.length) {
      error = resp.errors[0];
    }
    if (!error) {
      error = { displayMessage: resp.upsertItemRelationship?.errorMessage };
    }
    let errorMessage = error?.displayMessage || error?.errorMessage;
    if (!errorMessage) {
      throw new Error('Something went wrong, please try again.');
    }
    throw new Error(errorMessage);
  }
};

export const createUniOfRelationship =
  (f: Fetch) => async (itemId: number, parentItemId: number) => {
    if (!parentItemId)
      throw new Error(
        'Failed to create UNI of relationship: Missing parent item id.'
      );
    if (!itemId)
      throw new Error('Failed to create UNI of relationship: Missing item id.');
    const resp = await callContentMutation<any>(
      f,
      `mutation { 
        replicateItem (
            itemId: ${itemId}
            relationship: {
                item: { id: ${itemId} }, 
                replicateOptions: { replicateRelationshipType: "UNI_CHILD", uniUrl: "${parentItemId}" }
            }
        ) { 
                success 
                errorMessage
        } 
      }`
    );
    if (resp.error || resp.errors || !resp?.replicateItem?.success) {
      let error = resp.error;
      if (resp.errors?.length) {
        error = resp.errors[0];
      }
      if (!error) {
        error = { displayMessage: resp.replicateItem?.errorMessage };
      }
      let errorMessage = error?.displayMessage || error?.errorMessage;
      if (!errorMessage) {
        throw new Error('Something went wrong, please try again.');
      }
      errorMessage = errorMessage.replace('{0}', parentItemId);
      throw new Error(errorMessage);
    }
  };
